import { type ReactNode } from 'react'
import { NavLink } from 'react-router-dom'
import SovereigntyBar from './SovereigntyBar'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-bg-page flex flex-col">
      <SovereigntyBar />
      
      <nav className="bg-bg-surface border-b border-border px-6 py-3">
        <div className="flex items-center gap-6">
          <span className="font-semibold text-xl text-text-primary tracking-tight">
            Praxis<span className="text-action-primary">CRM</span>
          </span>
          
          <div className="flex gap-1 ml-8">
            <NavLink
              to="/pipeline"
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-medium rounded-[6px] transition-colors duration-150 ${
                  isActive
                    ? 'bg-action-primary text-white'
                    : 'text-text-secondary hover:text-text-primary hover:bg-[#F5F5F3]'
                }`
              }
            >
              Pipeline
            </NavLink>
            <NavLink
              to="/ledger"
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-medium rounded-[6px] transition-colors duration-150 ${
                  isActive
                    ? 'bg-action-primary text-white'
                    : 'text-text-secondary hover:text-text-primary hover:bg-[#F5F5F3]'
                }`
              }
            >
              Companies
            </NavLink>
            <NavLink
              to="/vault"
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-medium rounded-[6px] transition-colors duration-150 ${
                  isActive
                    ? 'bg-action-primary text-white'
                    : 'text-text-secondary hover:text-text-primary hover:bg-[#F5F5F3]'
                }`
              }
            >
              Data
            </NavLink>
            <NavLink
              to="/settings"
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-medium rounded-[6px] transition-colors duration-150 ${
                  isActive
                    ? 'bg-action-primary text-white'
                    : 'text-text-secondary hover:text-text-primary hover:bg-[#F5F5F3]'
                }`
              }
            >
              Settings
            </NavLink>
          </div>
        </div>
      </nav>

      <main className="flex-1 p-6 flex flex-col min-h-0">
        {children}
      </main>
    </div>
  )
}
